module.exports = __webpack_public_path__ + "static/media/api_connections.d20b3934.svg";